import * as Yup from "yup";
import * as _ from "lodash";

export const validationSchema = Yup.object({
  color: Yup.string().required("Required").min(1),
  placas: Yup.string().required("Required"),
  tipo_id: Yup.string().nullable().required("Requerido"),
  no_ruta: Yup.string().required("Requerido"),
  domicilio: Yup.string().required("Requerido"),
  estado_id: Yup.string().nullable().required("Requerido"),
  municipio: Yup.string().required("Requerido"),
  marca: Yup.string().required("Requerido"),
  color: Yup.string().required("Requerido"),
  placas: Yup.string().required("Requerido"),
  unidad: Yup.number().required("Required").typeError("Debe ser númerico"),
  concesion: Yup.string().required("Requerido"),
  tipo_bloqueo: Yup.string().required("Requerido"),
  celular: Yup.string().required("Requerido"),
  imei: Yup.string().required("Requerido"),
  serie: Yup.string().required("Requerido"),
  no_motor: Yup.string().required("Requerido"),
  chip: Yup.string().required("Requerido"),
  edo: Yup.string().required("Requerido"),
  equipamiento_id: Yup.string().nullable().required("Requerido"),
  modelo: Yup.string().required("Requerido"),
  empresa: Yup.string().required("Requerido"),
  anio: Yup.number().required("Required").typeError("Debe ser númerico"),
  colonia: Yup.string().required("Requerido"),
  tecnicos: Yup.array().min(1, "Requerido").required("Requerido"),
  operativeTests: Yup.object(),
  conditions: Yup.object(),
  files: Yup.object(),
});

const filesCatalog = [
  {
    fileType: "Vehículo de frente",
    name: "vfront",
    fileIds: [],
  },
  {
    fileType: "Vehículo de pado (placa visible)",
    name: "vside",
    fileIds: [],
  },
  {
    fileType: "Cuadro de instrumentos antes de instalar",
    name: "binstrument",
    fileIds: [],
  },
  {
    fileType: "Foto de la instalación",
    name: "install",
    fileIds: [],
  },
  {
    fileType: "Foto de Positivo",
    name: "positive",
    fileIds: [],
  },
  {
    fileType: "Foto de Negativo",
    name: "negative",
    fileIds: [],
  },
  {
    fileType: "Foto de Accesorios",
    name: "accesories",
    fileIds: [],
  },
  {
    fileType: "Foto de Paro de Motor",
    name: "stop_motion",
    fileIds: [],
  },
  {
    fileType: "Foto de ubicación GPS/MDVR",
    name: "equipment",
    fileIds: [],
  },
  {
    fileType: "Foto de de cuadro de instrumentos despues de instalar",
    name: "ainstrument",
    fileIds: [],
  },
  {
    fileType: "Foto de tipo de bloqueo",
    name: "blocked",
    fileIds: [],
  },
  {
    fileType: "Foto de Chip",
    name: "photo_chip",
    fileIds: [],
  },
  {
    fileType: "Fotos Adicionales",
    name: "adds",
    fileIds: [],
  },
  {
    fileType: "Firma de Conformidad",
    name: "firm",
    fileIds: [],
  },
];

export const initialValues = {
  id: 0,
  fecha: "",
  tipo_id: null,
  no_ruta: "",
  domicilio: "",
  estado_id: null,
  municipio: "",
  marca: "",
  color: "",
  placas: "",
  unidad: "",
  concesion: "",
  tipo_bloqueo: "",
  celular: "",
  imei: "",
  serie: "",
  no_motor: "",
  chip: "",
  edo: "",
  usuario_id: null,
  equipamiento_id: null,
  modelo: "",
  ubicacion_gps: "",
  empresa: "",
  anio: "",
  colonia: "",
  company_id: null,
  tecnicos: [],
  conditions: {},
  operativeTests: {},
  files: _.keyBy(filesCatalog, "name"),
};

export const parseFormValues = (formValues) => {
  const { files, operativeTests, conditions, tecnicos } = formValues;
  return {
    ...formValues,
    /* files: _.values(files)
      .filter((i) => i.id)
      .map(({ id }) => id), */
    files: _.values(files).reduce((accumulator, currentFile) => {
      return accumulator.concat(currentFile.fileIds);
    }, []),
    operative_tests: _.values(operativeTests)
      .filter((i) => i.checked)
      .map(({ id }) => id),
    conditions: _.values(conditions)
      .filter((i) => i.works_on_start || i.works_on_finish)
      .map(({ id, works_on_start = false, works_on_finish = false }) => ({
        id,
        works_on_start,
        works_on_finish,
      })),
    tecnicos: tecnicos.map(({ id }) => id),
  };
};
